module.exports = __webpack_public_path__ + "CriticalBaths.webp?6040541ef5d568fda489719080031e9e";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalBaths.webp
// module id = 67
// module chunks = 0